import { bffJson } from "@/shared/api/client";
import { resolveIndividualClientId } from "@/domain/clients/individual-client";
import type { QuantPortfolioWire } from "@/domain/quant/portfolio-mapping";
import {
  quantPortfolioListQuery,
  type QuantPortfolioOwner,
} from "@/domain/quant/quant-portfolio-filters";

export async function fetchQuantPortfoliosBy(
  owner: QuantPortfolioOwner,
): Promise<QuantPortfolioWire[]> {
  const path = `v1/quant-portfolio${quantPortfolioListQuery(owner)}`;
  let read = listsInFlight.get(path);
  if (!read) {
    read = bffJson<unknown>(path).finally(() => listsInFlight.delete(path));
    listsInFlight.set(path, read);
  }
  const json = structuredClone(await read);
  return Array.isArray(json) ? (json as QuantPortfolioWire[]) : [];
}

export async function fetchQuantPortfolioSummariesBy(
  owner: QuantPortfolioOwner,
): Promise<QuantPortfolioSummaryWire[]> {
  const json = await bffJson<unknown>(
    `v1/quant-portfolio/summary${quantPortfolioListQuery(owner)}`,
  );
  return Array.isArray(json) ? (json as QuantPortfolioSummaryWire[]) : [];
}

export type QuantPortfolioSummaryWire = QuantPortfolioWire & {
  id: string;
  quant_portfolio_lineage_id?: string | null;
};

export async function fetchQuantPortfolios(individualId: string): Promise<QuantPortfolioWire[]> {
  const icId = await resolveIndividualClientId(individualId);
  if (!icId) {
    console.warn(
      `quant-portfolio list: individual ${individualId} has no individual-client row — no portfolios`,
    );
    return [];
  }
  return fetchQuantPortfoliosBy({ filter: "individual_client_id", clientId: icId });
}

const listsInFlight = new Map<string, Promise<unknown>>();
